import { getClientsApi } from '../../../apis/clients';
import { mapClientsByEmail } from '../../../utils/functions/clientEmailLookup';

export function getClientsByEmailAction(email) {
    return (dispatch, getState) =>
        getClientsApi
            .getClientsByEmail(getState(), { q: email })
            .then(response => mapClientsByEmail(response, email));
}

export default { getClientsByEmailAction };
